// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SearchFormController from "./search_form_controller"
import AprovalModalController from "./approval_modal_controller"
import ToggleNotificationsController from "./toggle_notifications_controller"
import PwaController from "./pwa_controller"
import LogoutController from "./logout_controller"
import SummaryGeneratorController from "./summary_generator_controller"
application.register("search-form", SearchFormController)
application.register("approval-modal", AprovalModalController)
application.register("toggle-notifications", ToggleNotificationsController)
application.register("pwa", PwaController)
application.register("logout", LogoutController)
application.register("summary-generator", SummaryGeneratorController)
